import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Routes, Route, Link, useParams, useNavigate, Navigate } from 'react-router-dom';
import { ToastProvider, useToast } from './Toast';
import api from './api';
import { compressImage } from './compress';

/* ===== OMG LOGO (inline base64) ===== */
const OMG_LOGO = 'data:image/png;base64,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';

/* ===== ICONS (inline SVGs) ===== */
const Icons = {
  Camera: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  Upload: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>,
  Image: ({ size = 24 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,
  QR: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="3" height="3"/><rect x="18" y="14" width="3" height="3"/><rect x="14" y="18" width="3" height="3"/><rect x="18" y="18" width="3" height="3"/></svg>,
  Settings: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  Download: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  Plus: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  X: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  ChevronLeft: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>,
  ChevronRight: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>,
  Play: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  Calendar: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Users: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Trash: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  Lock: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  Mic: ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>,
  Check: ({ size = 16 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
};

/* ===== NAVBAR ===== */
function Navbar({ showAdmin = false }) {
  return (
    <div className="page-container">
      <nav className="nav-header">
        <Link to="/" className="nav-brand">
          <Icons.Camera /> QR <span>Memories</span>
        </Link>
        {showAdmin && (
          <Link to="/admin" className="btn btn-ghost btn-sm">
            <Icons.Settings /> Admin
          </Link>
        )}
      </nav>
    </div>
  );
}

/* ===== MESAJ VOCAL IN GALERIE ===== */
// Un mesaj vocal nu are ce imagine sa arate. Fara placa asta, browserul
// incearca sa randeze fisierul .webm ca poza si iese o pictograma de fisier
// stricat, ca si cum s-ar fi pierdut inregistrarea.
function AudioTile({ eticheta = 'Mesaj vocal' }) {
  return (
    <div style={{
      position: 'absolute', inset: 0,
      background: 'linear-gradient(160deg, #33333a, #17171a)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8,
    }}>
      <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#F5C518', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1a1a1a' }}>
        <Icons.Mic />
      </div>
      <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.75)', fontWeight: 500 }}>{eticheta}</div>
    </div>
  );
}

/* ===== LIGHTBOX ===== */
function Lightbox({ files, currentIndex, onClose, onNav, onSave, saveLabel }) {
  const file = files[currentIndex];
  const [seSalveaza, setSeSalveaza] = useState(false);
  useEffect(() => { setSeSalveaza(false); }, [currentIndex]);
  if (!file) return null;

  const salveaza = async e => {
    e.stopPropagation();
    if (seSalveaza) return;
    setSeSalveaza(true);
    try { await onSave(file); } finally { setSeSalveaza(false); }
  };

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose}><Icons.X /></button>
      {currentIndex > 0 && (
        <button className="lightbox-nav prev" onClick={e => { e.stopPropagation(); onNav(-1); }}>
          <Icons.ChevronLeft />
        </button>
      )}
      <div onClick={e => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        {file.file_type === 'video' ? (
          <video src={api.getFileUrl(file.url)} controls autoPlay style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px' }} />
        ) : file.file_type === 'audio' ? (
          <div style={{ background: '#1f1f22', borderRadius: 14, padding: '26px 20px', width: 320, maxWidth: '90vw', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#F5C518', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1a1a1a' }}>
              <Icons.Mic size={26} />
            </div>
            <audio src={api.getFileUrl(file.url)} controls autoPlay style={{ width: '100%' }} />
          </div>
        ) : (
          <img src={api.getFileUrl(file.url)} alt="" style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px' }} />
        )}
        {(file.uploader_name || file.message) && (
          <div style={{ textAlign: 'center', maxWidth: '90vw' }}>
            {file.uploader_name && (
              <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#fff' }}>
                De la: {file.uploader_name}
              </div>
            )}
            {file.message && (
              <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>
                "{file.message}"
              </div>
            )}
          </div>
        )}
        {onSave && (
          <button
            onClick={salveaza}
            disabled={seSalveaza}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              background: '#F5C518', color: '#1a1a1a', border: 'none',
              borderRadius: 24, padding: '11px 22px', fontSize: '0.95rem', fontWeight: 700,
              fontFamily: 'inherit', cursor: seSalveaza ? 'default' : 'pointer',
              opacity: seSalveaza ? 0.6 : 1,
            }}
          >
            <Icons.Download /> {seSalveaza ? (saveLabel?.saving || '...') : (saveLabel?.save || 'Save')}
          </button>
        )}
      </div>
      {currentIndex < files.length - 1 && (
        <button className="lightbox-nav next" onClick={e => { e.stopPropagation(); onNav(1); }}>
          <Icons.ChevronRight />
        </button>
      )}
    </div>
  );
}

/* ===== HOME PAGE ===== */
function HomePage() {
  const HS = {
    page: { minHeight: '100vh', background: '#E8E8E8', fontFamily: "'Roboto', sans-serif", display: 'flex', flexDirection: 'column' },
    header: { background: '#F5C518', padding: '16px 20px', textAlign: 'center' },
    body: { flex: 1, padding: '40px 20px', maxWidth: 560, margin: '0 auto', width: '100%' },
    footer: { background: '#1a1a1a', padding: '24px 20px', textAlign: 'center', marginTop: 'auto' },
    featureCard: { background: '#fff', borderRadius: 14, padding: '20px', display: 'flex', gap: 16, alignItems: 'flex-start', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', marginBottom: 12 },
  };

  return (
    <div style={HS.page}>
      <GlobalRobotoStyle />
      <div style={HS.header}>
        <div style={{ fontSize: '1.6rem', fontWeight: 300, color: '#1a1a1a' }}>QR <span style={{ fontWeight: 700 }}>Stories</span></div>
        <div style={{ fontSize: '0.72rem', color: '#333', marginTop: 2 }}>powered by omgcabinafoto.ro</div>
      </div>

      <div style={HS.body}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ marginBottom: 16 }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#F5C518" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
          </div>
          <h1 style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 300, color: '#1a1a1a', fontSize: 'clamp(1.8rem, 6vw, 2.4rem)', margin: 0 }}>
            QR <span style={{ fontWeight: 700 }}>Stories</span>
          </h1>
          <p style={{ color: '#777', marginTop: 12, fontWeight: 300, lineHeight: 1.6, fontSize: '0.95rem' }}>
            Strânge toate pozele și clipurile de la evenimentul tău într-un singur album digital. Simplu, elegant, memorabil.
          </p>
          <Link to="/admin" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '14px 32px', border: 'none', borderRadius: 12,
            background: '#F5C518', color: '#1a1a1a', fontSize: '1rem',
            fontWeight: 600, fontFamily: "'Roboto', sans-serif",
            textDecoration: 'none', marginTop: 24, transition: 'all 0.2s ease'
          }}>
            <Icons.Plus /> Creează Eveniment
          </Link>
        </div>

        {[
          { icon: <Icons.QR />, title: 'Cod QR Unic', desc: 'Generezi un cod QR personalizat pentru evenimentul tău.' },
          { icon: <Icons.Upload />, title: 'Invitații Încarcă', desc: 'Scanează, alege pozele și gata. Fără aplicații, fără conturi.' },
          { icon: <Icons.Image />, title: 'Album Digital', desc: 'Toate pozele și clipurile, într-un singur loc. Le descarci oricând.' },
        ].map((item, i) => (
          <div key={i} style={HS.featureCard}>
            <div style={{ color: '#F5C518', flexShrink: 0, marginTop: 2 }}>{item.icon}</div>
            <div>
              <h3 style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 500, color: '#1a1a1a', margin: '0 0 4px', fontSize: '1rem' }}>{item.title}</h3>
              <p style={{ fontSize: '0.88rem', color: '#888', margin: 0, fontWeight: 300 }}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div style={HS.footer}><img src={OMG_LOGO} alt="OMG! Cabina Foto" style={{ height: 50, maxWidth: '70%', objectFit: 'contain', opacity: 0.9 }} /></div>
    </div>
  );
}

/* ===== TRANSLATIONS ===== */
const translations = {
  ro: {
    headerTitle: 'QR',
    headerTitleBold: 'Stories',
    headerSub: 'powered by omgcabinafoto.ro',
    subtitle: 'Adaugă fotografiile și videoclipurile tale\nși contribuie la povestea nunții.',
    subtileBaptism: 'Adaugă fotografiile și videoclipurile tale\nși contribuie la povestea botezului.',
    subtitleGeneric: 'Adaugă fotografiile și videoclipurile tale\nși contribuie la povestea evenimentului.',
    namePlaceholder: 'Numele',
    uploadTitle: 'Încarcă',
    uploadTitleBold: 'poze / video din telefon',
    uploadBtn: 'Încarcă fișiere!',
    uploading: 'Se încarcă...',
    galleryBtn: 'Vezi galeria',
    successTitle: 'Mulțumim!',
    successMsg: 'Fotografiile tale au fost încărcate cu succes.',
    uploadMore: 'Încarcă altele',
    notFound: 'Eveniment negăsit',
    notFoundMsg: 'Acest link nu este valid sau evenimentul a fost șters.',
    inactive: 'Acest eveniment nu mai acceptă încărcări.',
    noPhotos: 'Nu sunt poze încă. Fii primul care încarcă!',
    back: 'Înapoi',
    save: 'Salvează',
    saving: 'Se pregătește...',
    saved: 'Salvat în telefon',
    savedDownload: 'Descărcat',
    saveFailed: 'Nu am reușit să salvez poza.',
    select: 'Selectează',
    cancelSelect: 'Renunță',
    selectAll: 'Toate',
    selectAllCapped: n => `Am bifat primele ${n}. Pentru restul folosește „Descarcă tot”.`,
    selectedCount: n => `${n} selectate`,
    downloadSelected: 'Descarcă selecția',
    downloadPanel: 'Descarcă pozele',
    downloadAll: 'Descarcă tot',
    downloadPhotosOnly: 'Doar pozele',
    downloadPart: n => `Partea ${n}`,
    downloadParts: n => `Arhiva e mare, așa că vine în ${n} părți. Descarcă-le pe rând.`,
    downloadHint: 'Descărcarea poate dura câteva minute. Nu închide pagina.',
    downloadStarted: 'Descărcarea a început.',
    downloadOff: 'Descărcarea nu este activată pentru acest eveniment.',
    downloadError: 'Descărcarea nu a putut porni. Încearcă din nou.',
    nothingSelected: 'Nu ai selectat nimic.',
    voiceMessage: 'Mesaj vocal',
  },
  en: {
    headerTitle: 'QR',
    headerTitleBold: 'Stories',
    headerSub: 'powered by omgcabinafoto.ro',
    subtitle: 'Add your photos and videos\nand contribute to the wedding story.',
    subtileBaptism: 'Add your photos and videos\nand contribute to the baptism story.',
    subtitleGeneric: 'Add your photos and videos\nand contribute to the event story.',
    namePlaceholder: 'Your Name',
    uploadTitle: 'Upload',
    uploadTitleBold: 'photos / videos from phone',
    uploadBtn: 'Upload files!',
    uploading: 'Uploading...',
    galleryBtn: 'View gallery',
    successTitle: 'Thank you!',
    successMsg: 'Your photos have been uploaded successfully.',
    uploadMore: 'Upload more',
    notFound: 'Event not found',
    notFoundMsg: 'This link is not valid or the event was deleted.',
    inactive: 'This event is no longer accepting uploads.',
    noPhotos: 'No photos yet. Be the first to upload!',
    back: 'Back',
    save: 'Save',
    saving: 'Preparing...',
    saved: 'Saved to your phone',
    savedDownload: 'Downloaded',
    saveFailed: 'Could not save the photo.',
    select: 'Select',
    cancelSelect: 'Cancel',
    selectAll: 'All',
    selectAllCapped: n => `Selected the first ${n}. For the rest use "Download all".`,
    selectedCount: n => `${n} selected`,
    downloadSelected: 'Download selection',
    downloadPanel: 'Download photos',
    downloadAll: 'Download all',
    downloadPhotosOnly: 'Photos only',
    downloadPart: n => `Part ${n}`,
    downloadParts: n => `The archive is large, so it comes in ${n} parts. Download them one by one.`,
    downloadHint: 'This may take a few minutes. Please keep the page open.',
    downloadStarted: 'Download started.',
    downloadOff: 'Downloading is not enabled for this event.',
    downloadError: 'The download could not start. Please try again.',
    nothingSelected: 'Nothing selected.',
    voiceMessage: 'Voice message',
  }
};

/* ===== FLAG ICONS ===== */
const FlagRO = () => (
  <svg width="28" height="20" viewBox="0 0 28 20" style={{ borderRadius: 3, display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}>
    <rect width="9.33" height="20" fill="#002B7F" />
    <rect x="9.33" width="9.33" height="20" fill="#FCD116" />
    <rect x="18.66" width="9.34" height="20" fill="#CE1126" />
  </svg>
);

const FlagEN = () => (
  <svg width="28" height="20" viewBox="0 0 28 20" style={{ borderRadius: 3, display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}>
    <rect width="28" height="20" fill="#012169" />
    <path d="M0 0L28 20M28 0L0 20" stroke="white" strokeWidth="3.5" />
    <path d="M0 0L28 20M28 0L0 20" stroke="#C8102E" strokeWidth="2" />
    <path d="M14 0V20M0 10H28" stroke="white" strokeWidth="5.5" />
    <path d="M14 0V20M0 10H28" stroke="#C8102E" strokeWidth="3" />
  </svg>
);

/* ===== UPLOAD ICON (yellow) ===== */
const UploadCloudIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F5C518" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 16 12 12 8 16" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </svg>
);

/* Marimea scrisa pe intelesul cuiva care sta pe date mobile: sub un gigabait
   raportam in megabaiti rotunzi, peste, in gigabaiti cu o zecimala. */
function marimeOmeneasca(octeti) {
  if (!octeti) return '0 MB';
  const mb = octeti / 1048576;
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${Math.round(mb)} MB`;
}

/* ===== EVENT UPLOAD PAGE (PUBLIC) — REDESIGNED ===== */
function EventPage() {
  const { slug } = useParams();
  const toast = useToast();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('upload'); // 'upload' | 'gallery' | 'success'
  const [files, setFiles] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [uploaderName, setUploaderName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [statusLine, setStatusLine] = useState('');
  const [resuming, setResuming] = useState(0); // cate fisiere reia acum
  const [resumed, setResumed] = useState(null); // rezultatul reluarii automate
  const [bgHandoff, setBgHandoff] = useState(false); // trimiterea a trecut in grija sistemului
  const [lightboxIndex, setLightboxIndex] = useState(-1);
  const [lang, setLang] = useState('ro');
  const [descarcare, setDescarcare] = useState(null); // ce se poate lua din galerie
  const [modSelectie, setModSelectie] = useState(false);
  const [alese, setAlese] = useState(() => new Set());
  const [pregatesteZip, setPregatesteZip] = useState(false);
  const fileInputRef = useRef();
  const t = translations[lang];

  useEffect(() => {
    api.getEvent(slug)
      .then(e => { setEvent(e); setLoading(false); })
      .catch(() => { setLoading(false); });
  }, [slug]);

  // Ce a ramas neterminat data trecuta pleaca singur, fara ca invitatul sa
  // apese ceva. Cazul obisnuit: a pornit un clip, a iesit sa mai faca o poza si
  // a revenit peste un sfert de ora — atunci continuam din octetul confirmat de
  // server, nu de la zero.
  useEffect(() => {
    let cancelled = false;
    api.resumePending(
      slug,
      (pct) => { if (!cancelled) setProgress(pct); },
      (count) => { if (!cancelled) setResuming(count); }
    )
      .then(res => {
        if (cancelled) return;
        setProgress(0);
        if (res && res.uploaded > 0) setResumed(res);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setResuming(0); });
    return () => { cancelled = true; };
  }, [slug]);

  const loadGallery = useCallback(() => {
    api.getAllGallery(slug).then(data => setGallery(data.files));
  }, [slug]);

  useEffect(() => { if (view === 'gallery') loadGallery(); }, [view, loadGallery]);

  // Ce poate lua invitatul cu el. Reintrebam cand se schimba numarul de poze,
  // altfel marimile de pe butoane ar ramane cele de dinaintea ultimului upload.
  useEffect(() => {
    if (view !== 'gallery') return;
    api.getDownloadInfo(slug).then(setDescarcare).catch(() => setDescarcare({ allowed: false }));
  }, [view, slug, gallery.length]);

  // Daca in eveniment sunt doar mesaje vocale, nu e nimic de pus in arhiva:
  // atunci panoul de descarcare nu are ce sa ofere si nu apare deloc.
  const potDescarca = !!(descarcare && descarcare.allowed && descarcare.all && descarcare.all.count > 0);
  // Un fisier singur se poate salva si cand nu e nimic de arhivat: un mesaj
  // vocal se ia de unul singur, prin ruta de fisier.
  const potSalva = !!(descarcare && descarcare.allowed);

  // O poza salvata prin navigator.share ajunge in galeria telefonului; una
  // salvata prin link ajunge doar in Descarcari. De aceea mesajele difera.
  const salveazaFisier = async (file) => {
    try {
      const rezultat = await api.saveFile(slug, file);
      if (rezultat === 'shared') toast(t.saved, 'success');
      else if (rezultat === 'downloaded') toast(t.savedDownload, 'success');
    } catch {
      toast(t.saveFailed, 'error');
    }
  };

  const comutaAleasa = (id) => setAlese(prev => {
    const noi = new Set(prev);
    if (noi.has(id)) noi.delete(id); else noi.add(id);
    return noi;
  });

  const iesiDinSelectie = () => { setModSelectie(false); setAlese(new Set()); };

  const descarcaArhiva = (params) => {
    api.openDownload(api.getZipUrl(slug, params));
    toast(t.downloadStarted, 'success');
  };

  const MAX_SELECTIE = 500;
  const alegeTot = () => {
    const ids = gallery.map(f => f.id).slice(0, MAX_SELECTIE);
    setAlese(new Set(ids));
    if (gallery.length > MAX_SELECTIE) toast(t.selectAllCapped(MAX_SELECTIE), 'info');
  };

  const stilDescarca = { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', background: '#F5C518', color: '#1a1a1a', border: 'none', borderRadius: 10, padding: '12px 16px', fontSize: '0.88rem', fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', marginBottom: 8 };
  const stilSecundar = { ...stilDescarca, background: '#fff', border: '1px solid #ddd', fontWeight: 500 };
  const stilPachet = { ...stilDescarca, width: 'auto', marginBottom: 0, padding: '9px 14px', fontSize: '0.82rem' };

  // O arhiva de cateva gigabaiti nu ajunge intreaga pe un telefon: se rupe
  // legatura si se ia de la capat. De aceea serverul o imparte in pachete si
  // aici arata un buton pentru fiecare.
  const randArhiva = (cheie, eticheta, info) => {
    if (!info || !info.count) return null;
    const pachete = info.packets || [];
    const rezumat = `${eticheta} · ${info.count} · ${marimeOmeneasca(info.size)}`;
    if (pachete.length <= 1) {
      return (
        <button key={cheie} style={cheie === 'all' ? stilDescarca : stilSecundar} onClick={() => descarcaArhiva({ only: cheie })}>
          <Icons.Download /> {rezumat}
        </button>
      );
    }
    return (
      <div key={cheie} style={{ marginBottom: 10 }}>
        <div style={{ fontSize: '0.85rem', fontWeight: 700, marginBottom: 4 }}>{rezumat}</div>
        <div style={{ fontSize: '0.75rem', color: '#666', fontWeight: 300, marginBottom: 8 }}>{t.downloadParts(pachete.length)}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {pachete.map(p => (
            <button key={p.part} style={stilPachet} onClick={() => descarcaArhiva({ only: cheie, part: p.part })}>
              <Icons.Download /> {t.downloadPart(p.part)} · {marimeOmeneasca(p.size)}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const descarcaSelectia = async () => {
    if (alese.size === 0) { toast(t.nothingSelected, 'error'); return; }
    setPregatesteZip(true);
    try {
      const marca = await api.createSelection(slug, [...alese]);
      descarcaArhiva({ sel: marca.token });
      iesiDinSelectie();
    } catch (err) {
      toast(err.message || t.downloadError, 'error');
    } finally {
      setPregatesteZip(false);
    }
  };

  const maxFileSize = event?.max_file_size || 200 * 1024 * 1024;
  const maxFiles = event?.max_files || 20;
  const maxTotalSize = event?.max_total_size || 500 * 1024 * 1024;
  const maxFileMb = Math.round(maxFileSize / (1024 * 1024));
  const maxTotalMb = Math.round(maxTotalSize / (1024 * 1024));

  const totalBytes = files.reduce((sum, f) => sum + f.size, 0);
  const totalMb = totalBytes / 1048576;
  const overTotal = totalBytes > maxTotalSize;
  const overCount = files.length > maxFiles;
  // Cat timp terminam ce a ramas din vizita trecuta nu pornim un al doilea
  // upload peste el: ar concura pe aceleasi sesiuni de pe server.
  const canUpload = files.length > 0 && !overTotal && !overCount && !uploading && !resuming;

  // Motivul pentru care nu se poate trimite, afisat permanent langa buton.
  // Un toast dispare; invitatul trebuie sa vada ce are de facut cat timp
  // se uita la lista de fisiere.
  const blockReason = overTotal
    ? (lang === 'ro'
        ? `Ai selectat ${files.length} fișiere — ${totalMb.toFixed(0)} MB în total. Poți trimite maxim ${maxTotalMb} MB odată. Șterge câteva fișiere din listă sau trimite-le în două reprize.`
        : `You selected ${files.length} files — ${totalMb.toFixed(0)} MB total. The limit is ${maxTotalMb} MB at once. Remove some files or send them in two batches.`)
    : overCount
      ? (lang === 'ro'
          ? `Ai selectat ${files.length} fișiere. Poți trimite maxim ${maxFiles} odată — șterge ${files.length - maxFiles} din listă.`
          : `You selected ${files.length} files. The limit is ${maxFiles} at once — remove ${files.length - maxFiles}.`)
      : null;

  const handleFiles = (e) => {
    const newFiles = Array.from(e.target.files || e.dataTransfer?.files || []);

    // Fisierele individual prea mari se scot automat: nu are rost sa ocupe loc
    // in lista cand serverul oricum le refuza.
    const tooBig = newFiles.filter(f => f.size > maxFileSize);
    const accepted = newFiles.filter(f => f.size <= maxFileSize);

    if (tooBig.length > 0) {
      const names = tooBig
        .map(f => `${f.name} (${(f.size / 1048576).toFixed(0)} MB)`)
        .join(', ');
      toast(
        lang === 'ro'
          ? `Prea mare, limita e ${maxFileMb} MB per fișier: ${names}. Trimite clipul mai scurt sau filmat la calitate mai mică.`
          : `Too large, limit is ${maxFileMb} MB per file: ${names}. Try a shorter clip or lower quality.`,
        'error'
      );
    }

    if (accepted.length > 0) {
      setFiles(prev => [...prev, ...accepted].slice(0, maxFiles + 5));
    }
  };

  const removeFile = (i) => setFiles(prev => prev.filter((_, idx) => idx !== i));

  const handleUpload = async () => {
    if (files.length === 0 || overTotal || overCount) return;
    setUploading(true);
    setProgress(0);
    setStatusLine(lang === 'ro' ? 'Pregătim fișierele...' : 'Preparing files...');
    try {
      // Comprimam inainte de trimitere: pe 4G fiecare MB inseamna timp de
      // asteptare si trafic consumat din abonamentul invitatului.
      const prepared = [];
      for (const f of files) {
        prepared.push(await compressImage(f));
      }

      // Pe Android sistemul poate duce fisierele la capat si dupa ce invitatul
      // inchide browserul. Daca accepta, nu-l mai tinem sa se uite la bara.
      if (await api.uploadInBackground(slug, prepared, uploaderName, '')) {
        setFiles([]);
        setStatusLine('');
        setBgHandoff(true);
        setView('success');
        return;
      }

      const result = await api.uploadFiles(slug, prepared, uploaderName, '', (pct, info) => {
        setProgress(pct);
        if (info && info.name) {
          setStatusLine(
            lang === 'ro'
              ? `Se trimite ${info.index + 1} din ${info.total}: ${info.name}`
              : `Sending ${info.index + 1} of ${info.total}: ${info.name}`
          );
        }
      });

      setProgress(100);
      setStatusLine('');
      // Contorul de pe butonul de galerie se misca imediat, fara sa mai intrebam serverul.
      if (result.uploaded > 0) {
        setEvent(prev => ({ ...prev, upload_count: (prev.upload_count || 0) + result.uploaded }));
      }

      // Succes partial: fisierele reusite raman salvate, in lista raman doar
      // cele care au esuat, ca invitatul sa poata reincerca doar pentru ele.
      if (result.failed && result.failed.length > 0) {
        const failedNames = new Set(result.failed.map(f => f.name));
        setFiles(prev => prev.filter(f => failedNames.has(f.name)));
        toast(
          lang === 'ro'
            ? `${result.uploaded} fișiere trimise. ${result.failed.length} nu au reușit — apasă din nou pentru a reîncerca.`
            : `${result.uploaded} files sent. ${result.failed.length} failed — press again to retry.`,
          'error'
        );
      } else {
        setFiles([]);
        setView('success');
      }
    } catch (err) {
      setStatusLine('');
      if (err.message === 'DEMO_MODE') {
        setView('demo');
      } else {
        // Mesajul serverului e specific (ex. fisier prea mare); pastreaza-l daca exista.
        const generic = lang === 'ro' ? 'Eroare la încărcare. Încearcă din nou.' : 'Upload failed. Try again.';
        toast(err.message && err.message !== 'Upload failed' ? err.message : generic, 'error');
      }
    } finally {
      setUploading(false);
    }
  };

  const getSubtitle = () => {
    // Use event description if set, otherwise fall back to default
    if (event && event.description) return event.description;
    if (!event) return t.subtitle;
    if (event.event_type === 'baptism') return t.subtileBaptism;
    if (event.event_type === 'wedding') return t.subtitle;
    return t.subtitleGeneric;
  };

  // Styles matching the Photoshop design
  const S = {
    page: { minHeight: '100vh', background: '#E8E8E8', fontFamily: "'Roboto', sans-serif", display: 'flex', flexDirection: 'column' },
    header: { background: '#F5C518', padding: '16px 20px', textAlign: 'center' },
    headerTitle: { fontSize: '1.6rem', fontWeight: 300, color: '#1a1a1a', letterSpacing: '0.02em' },
    headerTitleBold: { fontWeight: 700 },
    headerSub: { fontSize: '0.72rem', color: '#333', marginTop: 2, letterSpacing: '0.03em' },
    body: { flex: 1, padding: '28px 20px 20px', maxWidth: 480, margin: '0 auto', width: '100%', boxSizing: 'border-box' },
    coupleName: { fontFamily: "'Roboto', sans-serif", fontSize: 'clamp(1.8rem, 7vw, 2.4rem)', fontWeight: 300, color: '#1a1a1a', textAlign: 'center', lineHeight: 1.2 },
    date: { textAlign: 'center', fontSize: '0.95rem', color: '#555', marginTop: 4, fontWeight: 300 },
    desc: { textAlign: 'center', fontSize: '0.88rem', color: '#777', marginTop: 12, lineHeight: 1.6, whiteSpace: 'pre-line', fontWeight: 300 },
    card: { background: '#fff', borderRadius: 16, padding: '20px', marginTop: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
    inputLabel: { display: 'block', textAlign: 'center', fontSize: '0.92rem', fontWeight: 500, color: '#1a1a1a', marginBottom: 8 },
    input: { width: '100%', padding: '14px 16px', border: '1px solid #ddd', borderRadius: 10, fontSize: '0.95rem', fontFamily: "'Roboto', sans-serif", outline: 'none', boxSizing: 'border-box', background: '#f9f9f9', color: '#333', fontWeight: 300 },
    dropzone: { border: '2px dashed #F5C518', borderRadius: 14, padding: '28px 16px', textAlign: 'center', cursor: 'pointer', background: '#FFFEF5', marginTop: 12, transition: 'all 0.2s ease' },
    dropzoneTitle: { fontSize: '1rem', fontWeight: 500, color: '#1a1a1a', marginTop: 8 },
    dropzoneTitleBold: { fontWeight: 700 },
    dropzoneDesc: { fontSize: '0.78rem', color: '#888', marginTop: 6, lineHeight: 1.5, whiteSpace: 'pre-line', fontWeight: 300 },
    dropzoneCta: { display: 'inline-block', marginTop: 12, padding: '10px 22px', background: '#F5C518', color: '#1a1a1a', borderRadius: 999, fontSize: '0.9rem', fontWeight: 700, letterSpacing: '0.01em' },
    previewSize: { position: 'absolute', bottom: 4, left: 4, background: 'rgba(0,0,0,0.65)', color: '#fff', fontSize: '0.62rem', padding: '2px 5px', borderRadius: 4, fontWeight: 500 },
    meterWrap: { marginTop: 12 },
    meterTrack: { height: 6, background: '#eee', borderRadius: 999, overflow: 'hidden' },
    meterFill: { height: '100%', borderRadius: 999, transition: 'width 0.25s ease, background 0.25s ease' },
    meterLabel: { fontSize: '0.75rem', marginTop: 6, textAlign: 'right', fontWeight: 500 },
    blockNotice: { marginTop: 10, padding: '10px 12px', background: '#fdecea', border: '1px solid #f5c2bd', borderRadius: 10, color: '#8c1d13', fontSize: '0.8rem', lineHeight: 1.5 },
    dataNotice: { marginTop: 10, padding: '9px 12px', background: '#fff8e1', border: '1px solid #f2dfa0', borderRadius: 10, color: '#7a5c00', fontSize: '0.78rem', lineHeight: 1.5 },
    resumeNotice: { marginTop: 10, padding: '9px 12px', background: '#e8f0fe', border: '1px solid #c6d9f7', borderRadius: 10, color: '#174ea6', fontSize: '0.78rem', lineHeight: 1.5 },
    resumeDone: { marginTop: 10, padding: '9px 12px', background: '#e6f4ea', border: '1px solid #b7dfc4', borderRadius: 10, color: '#1e6b34', fontSize: '0.78rem', lineHeight: 1.5 },
    statusLine: { fontSize: '0.75rem', color: '#666', marginTop: 6, textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    btnPrimary: { width: '100%', padding: '16px', border: 'none', borderRadius: 12, background: '#F5C518', color: '#1a1a1a', fontSize: '1rem', fontWeight: 600, fontFamily: "'Roboto', sans-serif", cursor: 'pointer', marginTop: 12, transition: 'all 0.2s ease', letterSpacing: '0.01em' },
    // Optiune secundara, nu dezactivata: chenar galben in loc de umplere, ca sa se
    // vada ca se poate apasa fara sa concureze cu butonul de incarcare.
    btnGallery: { width: '100%', padding: '13px', border: '1.5px solid #F5C518', borderRadius: 12, background: '#fffdf3', color: '#1a1a1a', fontSize: '0.9rem', fontWeight: 500, fontFamily: "'Roboto', sans-serif", cursor: 'pointer', marginTop: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 },
    btnGalleryCount: { fontSize: '0.75rem', fontWeight: 500, color: '#8a6d0b', background: '#fff3c9', borderRadius: 20, padding: '2px 8px', lineHeight: 1.5 },
    footer: { background: '#1a1a1a', padding: '24px 20px', textAlign: 'center', marginTop: 'auto' },
    footerLogo: { fontSize: '1.4rem', fontWeight: 900, color: '#F5C518', fontStyle: 'italic' },
    footerSub: { fontSize: '0.7rem', color: '#999', letterSpacing: '0.15em', marginTop: 2, textTransform: 'uppercase' },
    langBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.8, transition: 'opacity 0.2s' },
    progressBar: { width: '100%', height: 4, background: '#e0e0e0', borderRadius: 2, overflow: 'hidden', marginTop: 8 },
    progressFill: { height: '100%', background: '#F5C518', borderRadius: 2, transition: 'width 0.3s ease' },
    previewGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))', gap: 6, marginTop: 12 },
    previewItem: { position: 'relative', aspectRatio: '1', borderRadius: 8, overflow: 'hidden', border: '1px solid #e0e0e0' },
    previewRemove: { position: 'absolute', top: 3, right: 3, width: 18, height: 18, borderRadius: '50%', background: 'rgba(0,0,0,0.6)', border: 'none', color: '#fff', fontSize: 10, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  };

  if (loading) return <div style={{ ...S.page, alignItems: 'center', justifyContent: 'center' }}><div className="spinner" /></div>;

  if (!event) return (
    <div style={S.page}>
      <div style={S.header}>
        <div style={S.headerTitle}>{t.headerTitle} <span style={S.headerTitleBold}>{t.headerTitleBold}</span></div>
        <div style={S.headerSub}>{t.headerSub}</div>
      </div>
      <div style={{ ...S.body, textAlign: 'center', paddingTop: 60 }}>
        <h2 style={{ fontWeight: 300, color: '#1a1a1a' }}>{t.notFound}</h2>
        <p style={{ color: '#777', marginTop: 8 }}>{t.notFoundMsg}</p>
      </div>
      <div style={S.footer}>
        <img src={OMG_LOGO} alt="OMG! Cabina Foto" style={{ height: 50, maxWidth: '70%', objectFit: 'contain', opacity: 0.9 }} />
      </div>
    </div>
  );

  const formatDate = (d) => {
    const opts = lang === 'ro'
      ? { day: 'numeric', month: 'long', year: 'numeric' }
      : { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(d).toLocaleDateString(lang === 'ro' ? 'ro-RO' : 'en-GB', opts);
  };

  return (
    <div style={S.page}>
      <GlobalRobotoStyle />

      {/* HEADER */}
      <div style={S.header}>
        <div style={S.headerTitle}>{t.headerTitle} <span style={S.headerTitleBold}>{t.headerTitleBold}</span></div>
        <div style={S.headerSub}>{t.headerSub}</div>
      </div>

      {/* BODY */}
      <div style={S.body}>

        {/* DEMO VIEW */}
        {view === 'demo' && (
          <div style={{ textAlign: 'center', paddingTop: 40, paddingBottom: 40 }}>
            <div style={{ fontSize: 56, marginBottom: 16 }}>🎉</div>
            <h2 style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '1.4rem', marginBottom: 10 }}>Ai testat cu succes!</h2>
            <p style={{ color: '#555', fontWeight: 300, lineHeight: 1.6, marginBottom: 20 }}>
              La evenimentul real, pozele tale ar fi fost salvate instant în galeria comună.
            </p>
            <div style={{ background: 'linear-gradient(135deg, #1a1a2e, #2d2d4e)', borderRadius: 14, padding: '16px 20px', marginBottom: 20, color: '#F5C518', fontWeight: 500, lineHeight: 1.6 }}>
              📸 La eveniment vom colecta amintirile tale.<br />
              <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem', fontWeight: 300 }}>Acum ești în modul demo — pozele nu se salvează.</span>
            </div>
            <button style={{ ...S.btnPrimary, maxWidth: 280 }} onClick={() => { setView('upload'); setFiles([]); }}>
              Încearcă din nou
            </button>
          </div>
        )}

        {/* SUCCESS VIEW */}
        {view === 'success' && (
          <div style={{ textAlign: 'center', paddingTop: 40 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
            <h2 style={{ fontWeight: 300, color: '#1a1a1a', fontSize: '1.6rem' }}>{t.successTitle}</h2>
            <p style={{ color: '#777', marginTop: 8, fontWeight: 300 }}>{t.successMsg}</p>
            {/* Predat sistemului: invitatul poate inchide linistit aplicatia. */}
            {bgHandoff && (
              <p style={{ ...S.resumeNotice, textAlign: 'left', maxWidth: 320, margin: '16px auto 0' }}>
                {lang === 'ro'
                  ? 'Trimiterea continuă în fundal — poți închide aplicația liniștit. Vei vedea progresul în notificări.'
                  : 'The upload continues in the background — you can close the app. Progress shows in your notifications.'}
              </p>
            )}
            <button style={{ ...S.btnPrimary, marginTop: 24, maxWidth: 280 }} onClick={() => { setView('upload'); setFiles([]); }}>
              {t.uploadMore}
            </button>
          </div>
        )}

        {/* UPLOAD VIEW */}
        {view === 'upload' && (
          <>
            {/* Couple Name & Date */}
            <h1 style={S.coupleName}>{event.couple_names || event.name}</h1>
            <div style={S.date}>{formatDate(event.date)}</div>
            <p style={S.desc}>{getSubtitle()}</p>

            {!event.is_active ? (
              <div style={{ ...S.card, textAlign: 'center' }}>
                <p style={{ color: '#777', fontWeight: 300 }}>{t.inactive}</p>
                {event.nextcloud_share_url && (
                  <a
                    href={event.nextcloud_share_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      marginTop: 16,
                      padding: '12px 24px',
                      background: event.accent_color || '#c9a96e',
                      color: '#fff',
                      borderRadius: 8,
                      textDecoration: 'none',
                      fontWeight: 500,
                      fontSize: '1rem',
                    }}
                  >
                    ☁️ Accesează galeria foto
                  </a>
                )}
              </div>
            ) : (
              <div style={S.card}>
                {/* Name Input */}
                <div style={S.inputLabel}>{t.namePlaceholder}</div>
                <input
                  style={S.input}
                  value={uploaderName}
                  onChange={e => setUploaderName(e.target.value)}
                  placeholder=""
                />

                {/* Dropzone */}
                <div
                  style={S.dropzone}
                  onClick={() => fileInputRef.current?.click()}
                  onDragOver={e => e.preventDefault()}
                  onDrop={e => { e.preventDefault(); handleFiles(e); }}
                >
                  <UploadCloudIcon />
                  <div style={S.dropzoneTitle}>
                    {lang === 'ro' ? 'Apasă aici' : 'Tap here'}<br />
                    <span style={S.dropzoneTitleBold}>
                      {lang === 'ro' ? 'și încarcă poze / video din telefon' : 'and upload photos / videos'}
                    </span>
                  </div>
                  {/* Buton fals: dropzone-ul intreg e clicabil, dar pe mobil o zona
                      punctata nu se citeste ca buton. Asta face actiunea evidenta. */}
                  <div style={S.dropzoneCta}>
                    {lang === 'ro' ? 'Alege fișiere' : 'Choose files'}
                  </div>
                  <div style={S.dropzoneDesc}>
                    {lang === 'ro'
                      ? `Poze și clipuri video - max ${maxFiles} fișiere -\nMax ${maxFileMb} MB / fișier`
                      : `Photos and videos - max ${maxFiles} files -\nMax ${maxFileMb} MB / file`}
                  </div>
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept="image/*,video/*"
                    onChange={handleFiles}
                    style={{ display: 'none' }}
                  />
                </div>

                {/* File Previews */}
                {files.length > 0 && (
                  <div style={S.previewGrid}>
                    {files.map((f, i) => (
                      <div key={i} style={S.previewItem}>
                        {f.type.startsWith('image/') ? (
                          <img src={URL.createObjectURL(f)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <div style={{ width: '100%', height: '100%', background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Icons.Play />
                          </div>
                        )}
                        <button style={S.previewRemove} onClick={() => removeFile(i)}>✕</button>
                        <span style={S.previewSize}>{(f.size / 1048576).toFixed(f.size > 10485760 ? 0 : 1)} MB</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Contor permanent: cat s-a selectat fata de cat se poate trimite */}
                {files.length > 0 && (
                  <div style={S.meterWrap}>
                    <div style={S.meterTrack}>
                      <div
                        style={{
                          ...S.meterFill,
                          width: `${Math.min(100, (totalBytes / maxTotalSize) * 100)}%`,
                          background: overTotal ? '#d93025' : '#2e7d32'
                        }}
                      />
                    </div>
                    {/* Fiecare jumatate se coloreaza dupa propria limita. Altfel,
                        cand doar numarul de fisiere e depasit, cifra MB apare rosie
                        si invitatul crede ca dimensiunea e problema. */}
                    <div style={S.meterLabel}>
                      <span style={{ color: overCount ? '#d93025' : '#666' }}>
                        {files.length} {lang === 'ro' ? 'fișiere' : 'files'}
                      </span>
                      <span style={{ color: '#bbb' }}> · </span>
                      <span style={{ color: overTotal ? '#d93025' : '#666' }}>
                        {totalMb.toFixed(totalMb > 10 ? 0 : 1)} MB / {maxTotalMb} MB
                      </span>
                    </div>
                  </div>
                )}

                {/* Motivul blocarii, vizibil permanent langa buton */}
                {blockReason && <div style={S.blockNotice}>{blockReason}</div>}

                {/* Avertisment de trafic mobil: invitatul decide informat,
                    nu descopera dupa ce i-a plecat traficul din abonament. */}
                {!blockReason && totalBytes > 50 * 1048576 && (
                  <div style={S.dataNotice}>
                    {lang === 'ro'
                      ? `Se vor trimite ${totalMb.toFixed(0)} MB din traficul tău mobil. Pe Wi-Fi merge mai repede.`
                      : `This will use ${totalMb.toFixed(0)} MB of mobile data. Wi-Fi will be faster.`}
                  </div>
                )}

                {/* Continuarea de la vizita trecuta, pornita singura */}
                {resuming > 0 && (
                  <div style={S.resumeNotice}>
                    {lang === 'ro'
                      ? `Continuăm trimiterea a ${resuming} ${resuming === 1 ? 'fișier' : 'fișiere'} rămase de data trecută — ${progress}%`
                      : `Finishing ${resuming} file${resuming === 1 ? '' : 's'} left from last time — ${progress}%`}
                  </div>
                )}
                {resumed && (
                  <div style={S.resumeDone}>
                    {lang === 'ro'
                      ? `Am terminat de trimis ${resumed.uploaded} ${resumed.uploaded === 1 ? 'fișier' : 'fișiere'} rămase de data trecută.`
                      : `Sent ${resumed.uploaded} file${resumed.uploaded === 1 ? '' : 's'} left from last time.`}
                  </div>
                )}

                {/* Progress */}
                {(uploading || resuming > 0) && (
                  <>
                    <div style={S.progressBar}>
                      <div style={{ ...S.progressFill, width: `${progress}%` }} />
                    </div>
                    {statusLine && <div style={S.statusLine}>{statusLine}</div>}
                  </>
                )}

                {/* Upload Button */}
                <button
                  style={{ ...S.btnPrimary, opacity: canUpload ? 1 : 0.5, cursor: canUpload ? 'pointer' : 'not-allowed' }}
                  onClick={handleUpload}
                  disabled={!canUpload}
                >
                  {uploading
                    ? `${t.uploading} ${progress}%`
                    : overTotal
                      ? (lang === 'ro' ? 'Prea mult — șterge câteva fișiere' : 'Too much — remove some files')
                      : overCount
                        ? (lang === 'ro' ? `Prea multe — maxim ${maxFiles}` : `Too many — max ${maxFiles}`)
                        : t.uploadBtn}
                </button>

                {/* Gallery Tease Button */}
                {event.public_gallery ? (
                  <button style={S.btnGallery} onClick={() => setView('gallery')}>
                    <Icons.Image size={18} />
                    {t.galleryBtn}
                    {/* Contorul vine gata numarat cu evenimentul, nu costa un apel in plus.
                        La galerie goala il ascundem: "0" descurajeaza, nu invita. */}
                    {event.upload_count > 0 && (
                      <span style={S.btnGalleryCount}>{event.upload_count}</span>
                    )}
                  </button>
                ) : null}
              </div>
            )}

            {/* Audio Guestbook */}
            {event.is_active && (
              process.env.REACT_APP_DEMO_MODE === 'true'
                ? <AudioGuestbookDemo />
                : <AudioGuestbook slug={slug} lang={lang} uploaderName={uploaderName} />
            )}

            {/* Language Toggle */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
              <button style={S.langBtn} onClick={() => setLang(lang === 'ro' ? 'en' : 'ro')}>
                {lang === 'ro' ? <FlagEN /> : <FlagRO />}
              </button>
            </div>
          </>
        )}

        {/* GALLERY VIEW */}
        {view === 'gallery' && (
          <div>
            <button
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Roboto', sans-serif", fontSize: '0.9rem', color: '#555', display: 'flex', alignItems: 'center', gap: 4, marginBottom: 16, fontWeight: 300 }}
              onClick={() => setView('upload')}
            >
              <Icons.ChevronLeft /> {t.back}
            </button>
            {gallery.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                <Icons.Image />
                <p style={{ marginTop: 8, fontWeight: 300 }}>{t.noPhotos}</p>
              </div>
            ) : (
              <>
                {potDescarca && (
                  <div style={{ background: '#fff', borderRadius: 14, padding: 16, marginBottom: 16, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                    {!modSelectie ? (
                      <>
                        <div style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 12 }}>{t.downloadPanel}</div>
                        {randArhiva('all', t.downloadAll, descarcare.all)}
                        {descarcare.photos && descarcare.all && descarcare.photos.count > 0 && descarcare.photos.count < descarcare.all.count &&
                          randArhiva('photos', t.downloadPhotosOnly, descarcare.photos)}
                        <button style={stilSecundar} onClick={() => setModSelectie(true)}>
                          <Icons.Check /> {t.select}
                        </button>
                        <div style={{ fontSize: '0.72rem', color: '#999', fontWeight: 300, textAlign: 'center' }}>{t.downloadHint}</div>
                      </>
                    ) : (
                      <>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                          <span style={{ fontSize: '0.95rem', fontWeight: 700 }}>{t.selectedCount(alese.size)}</span>
                          <button
                            style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: '0.85rem', color: '#555', textDecoration: 'underline' }}
                            onClick={alegeTot}
                          >{t.selectAll}</button>
                        </div>
                        <button
                          style={{ ...stilDescarca, opacity: (pregatesteZip || alese.size === 0) ? 0.5 : 1, cursor: (pregatesteZip || alese.size === 0) ? 'default' : 'pointer' }}
                          disabled={pregatesteZip || alese.size === 0}
                          onClick={descarcaSelectia}
                        >
                          <Icons.Download /> {pregatesteZip ? t.saving : t.downloadSelected}
                        </button>
                        <button style={stilSecundar} onClick={iesiDinSelectie}>{t.cancelSelect}</button>
                      </>
                    )}
                  </div>
                )}
                <div className="gallery-grid">
                  {gallery.map((file, i) => {
                    const bifata = alese.has(file.id);
                    // Mesajele vocale nu intra in arhive, deci nici in selectie:
                    // altfel invitatul le-ar bifa si nu le-ar gasi in ZIP.
                    const eAudio = file.file_type === 'audio';
                    return (
                      <div
                        key={file.id}
                        className="gallery-item"
                        style={modSelectie ? { outline: bifata ? '3px solid #F5C518' : 'none', outlineOffset: -3, opacity: eAudio ? 0.4 : 1 } : undefined}
                        onClick={() => {
                          if (!modSelectie) { setLightboxIndex(i); return; }
                          if (!eAudio) comutaAleasa(file.id);
                        }}
                      >
                        {file.file_type === 'video' ? (
                          <>
                            {file.thumbnail_name
                              ? <img src={api.getFileUrl(file.thumbnail_url)} alt="" loading="lazy" />
                              // Fara poster, Safari lasa elementul gol; fundalul inchis
                              // plus badge-ul de play il fac sa arate a clip, nu a eroare.
                              : <video src={api.getFileUrl(file.url)} muted preload="metadata" playsInline style={{ background: '#1a1a1a' }} />}
                            <div className="video-badge"><Icons.Play /></div>
                          </>
                        ) : eAudio ? (
                          <AudioTile eticheta={t.voiceMessage} />
                        ) : (
                          <img src={api.getFileUrl(file.thumbnail_url)} alt="" loading="lazy" />
                        )}
                        {modSelectie && !eAudio && (
                          <div style={{
                            position: 'absolute', top: 6, left: 6, width: 24, height: 24, borderRadius: '50%',
                            background: bifata ? '#F5C518' : 'rgba(0,0,0,0.35)',
                            border: bifata ? 'none' : '2px solid rgba(255,255,255,0.85)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: '#1a1a1a', pointerEvents: 'none',
                          }}>
                            {bifata && <Icons.Check size={14} />}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* FOOTER */}
      <div style={S.footer}>
        <img src={OMG_LOGO} alt="OMG! Cabina Foto" style={{ height: 50, maxWidth: '70%', objectFit: 'contain', opacity: 0.9 }} />
      </div>

      {/* LIGHTBOX */}
      {lightboxIndex >= 0 && (
        <Lightbox
          files={gallery}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(-1)}
          onNav={dir => setLightboxIndex(prev => Math.max(0, Math.min(gallery.length - 1, prev + dir)))}
          onSave={potSalva ? salveazaFisier : undefined}
          saveLabel={{ save: t.save, saving: t.saving }}
        />
      )}
    </div>
  );
}

/* ===== GLOBAL ROBOTO OVERRIDE ===== */
const GlobalRobotoStyle = () => (
  <>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap" rel="stylesheet" />
    <style dangerouslySetInnerHTML={{ __html: `
      h1, h2, h3, h4, h5, h6, p, span, div, button, input, textarea, select, a, label {
        font-family: 'Roboto', sans-serif !important;
      }
    `}} />
  </>
);

/* ===== ADMIN SHARED STYLES ===== */
const A = {
  page: { minHeight: '100vh', background: '#E8E8E8', fontFamily: "'Roboto', sans-serif", display: 'flex', flexDirection: 'column' },
  header: { background: '#F5C518', padding: '16px 20px', textAlign: 'center' },
  headerTitle: { fontSize: '1.6rem', fontWeight: 300, color: '#1a1a1a', letterSpacing: '0.02em' },
  headerBold: { fontWeight: 700 },
  headerSub: { fontSize: '0.72rem', color: '#333', marginTop: 2 },
  body: { flex: 1, padding: '24px 20px', maxWidth: 700, margin: '0 auto', width: '100%' },
  footer: { background: '#1a1a1a', padding: '24px 20px', textAlign: 'center', marginTop: 'auto' },
  card: { background: '#fff', borderRadius: 16, padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 },
  input: { width: '100%', padding: '12px 16px', border: '1px solid #ddd', borderRadius: 10, fontSize: '0.92rem', fontFamily: "'Roboto', sans-serif", outline: 'none', boxSizing: 'border-box', background: '#f9f9f9', color: '#333', fontWeight: 300 },
  label: { display: 'block', fontSize: '0.78rem', fontWeight: 500, color: '#555', letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 6 },
  btnY: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px 24px', border: 'none', borderRadius: 10, background: '#F5C518', color: '#1a1a1a', fontSize: '0.88rem', fontWeight: 600, fontFamily: "'Roboto', sans-serif", cursor: 'pointer', transition: 'all 0.2s ease' },
  btnW: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px 24px', border: '1px solid #ddd', borderRadius: 10, background: '#fff', color: '#333', fontSize: '0.88rem', fontWeight: 400, fontFamily: "'Roboto', sans-serif", cursor: 'pointer', transition: 'all 0.2s ease' },
  btnGhost: { background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Roboto', sans-serif", fontSize: '0.88rem', color: '#555', display: 'flex', alignItems: 'center', gap: 4, fontWeight: 300 },
  btnDanger: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 16px', border: 'none', borderRadius: 8, background: '#d45050', color: '#fff', fontSize: '0.82rem', fontWeight: 500, fontFamily: "'Roboto', sans-serif", cursor: 'pointer' },
  badge: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 100, fontSize: '0.72rem', fontWeight: 500 },
  badgeGreen: { background: 'rgba(92,184,122,0.15)', color: '#3a8a55', border: '1px solid rgba(92,184,122,0.3)' },
  badgeRed: { background: 'rgba(212,80,80,0.1)', color: '#c04040', border: '1px solid rgba(212,80,80,0.2)' },
  badgeGrey: { background: 'rgba(0,0,0,0.05)', color: '#777', border: '1px solid rgba(0,0,0,0.08)' },
  badgeYellow: { background: 'rgba(245,197,24,0.15)', color: '#a08000', border: '1px solid rgba(245,197,24,0.3)' },
  tabs: { display: 'flex', gap: 4, background: '#fff', borderRadius: 12, padding: 4, marginBottom: 20, boxShadow: '0 1px 6px rgba(0,0,0,0.04)' },
  tab: { flex: 1, padding: '10px 16px', border: 'none', borderRadius: 8, background: 'transparent', color: '#999', fontFamily: "'Roboto', sans-serif", fontSize: '0.84rem', fontWeight: 500, cursor: 'pointer', transition: 'all 0.2s ease', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 },
  tabOn: { background: '#F5C518', color: '#1a1a1a', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
  overlay: { position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  modal: { background: '#fff', borderRadius: 20, padding: 28, maxWidth: 540, width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  formFull: { gridColumn: '1 / -1' },
  select: { width: '100%', padding: '12px 16px', border: '1px solid #ddd', borderRadius: 10, fontSize: '0.92rem', fontFamily: "'Roboto', sans-serif", outline: 'none', background: '#f9f9f9', color: '#333', cursor: 'pointer', appearance: 'none', backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 14px center', paddingRight: 36 },
  eventItem: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 20px', background: '#fff', borderRadius: 14, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', cursor: 'pointer', transition: 'all 0.2s ease', gap: 12, marginBottom: 10, border: '1px solid transparent' },
};

/* ===== ADMIN HEADER ===== */
function AdminHeader() {
  return (
    <>
      <GlobalRobotoStyle />
      <div style={A.header}>
        <div style={A.headerTitle}>{translations.ro.headerTitle} <span style={A.headerBold}>{translations.ro.headerTitleBold}</span> <span style={{ fontSize: '0.9rem', fontWeight: 400 }}>— Admin</span></div>
        <div style={A.headerSub}>powered by omgcabinafoto.ro</div>
      </div>
    </>
  );
}

/* ===== ADMIN PAGE ===== */
function AdminPage() {
  const toast = useToast();
  const navigate = useNavigate();
  const MASTER_PW = 'omgmaster2025';
  const [password, setPassword] = useState(MASTER_PW);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [events, setEvents] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [creating, setCreating] = useState(false);

  const [form, setForm] = useState({
    name: '', date: '', couple_names: '', event_type: 'wedding',
    description: '', cover_color: '#1a1a2e', accent_color: '#c9a96e', admin_password: MASTER_PW, public_gallery: 1, custom_slug: ''
  });

  const loadEvents = useCallback(async (pw) => {
    try {
      const data = await api.getAdminEvents(pw);
      setEvents(data);
      setIsLoggedIn(true);
      localStorage.setItem('qr_admin_pw', pw);
    } catch {
      toast('Eroare la încărcarea evenimentelor.', 'error');
    }
  }, [toast]);

  // Auto-login cu parola master
  useEffect(() => {
    loadEvents(MASTER_PW);
  }, [loadEvents]);

  const handleLogin = (e) => { e.preventDefault(); loadEvents(password); };

  const handleLogout = () => {
    localStorage.removeItem('qr_admin_pw');
    setIsLoggedIn(false);
    setPassword('');
    setEvents([]);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.name || !form.date) { toast('Completează numele și data evenimentului.', 'error'); return; }
    setCreating(true);
    try {
      const pw = form.admin_password || password;
      await api.createEvent({ ...form, admin_password: pw });
      toast('Eveniment creat cu succes!', 'success');
      setShowCreate(false);
      setForm({ name: '', date: '', couple_names: '', event_type: 'wedding', description: '', cover_color: '#1a1a2e', accent_color: '#c9a96e', admin_password: '', public_gallery: 1, custom_slug: '' });
      loadEvents(pw);
    } catch (err) { toast(err.message, 'error'); }
    finally { setCreating(false); }
  };

  const handleDelete = async (slug) => {
    if (!window.confirm('Sigur vrei să ștergi acest eveniment? Toate pozele vor fi pierdute.')) return;
    try { await api.deleteEvent(slug, password); toast('Eveniment șters.', 'success'); loadEvents(password); }
    catch (err) { toast(err.message, 'error'); }
  };

  const formatSize = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024, sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  // LOGIN
  if (!isLoggedIn) {
    return (
      <div style={A.page}>
        <AdminHeader />
        <div style={{ ...A.body, maxWidth: 420, paddingTop: 48 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <Icons.Lock />
            <h2 style={{ fontWeight: 300, color: '#1a1a1a', marginTop: 12, fontSize: '1.5rem' }}>Admin Panel</h2>
            <p style={{ color: '#777', marginTop: 8, fontWeight: 300 }}>Introdu parola de admin pentru a gestiona evenimentele.</p>
          </div>
          <form onSubmit={handleLogin} style={A.card}>
            <div style={{ marginBottom: 14 }}>
              <div style={A.label}>Parolă Admin</div>
              <input style={A.input} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Parola ta" autoFocus />
            </div>
            <button type="submit" style={{ ...A.btnY, width: '100%' }}>Intră</button>
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.82rem', color: '#999', fontWeight: 300 }}>
              Prima dată? Creează un eveniment cu orice parolă.
            </p>
            <button type="button" style={{ ...A.btnW, width: '100%', marginTop: 8 }} onClick={() => { setIsLoggedIn(true); setShowCreate(true); }}>
              <Icons.Plus /> Creează Primul Eveniment
            </button>
          </form>
        </div>
        <div style={A.footer}><img src={OMG_LOGO} alt="OMG!" style={{ height: 50, maxWidth: '70%', objectFit: 'contain', opacity: 0.9 }} /></div>
      </div>
    );
  }

  // MAIN ADMIN
  return (
    <div style={A.page}>
      <AdminHeader />
      <div style={A.body}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
          <h2 style={{ fontWeight: 300, color: '#1a1a1a', fontSize: '1.4rem' }}>Evenimentele Tale</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={A.btnY} onClick={() => setShowCreate(true)}><Icons.Plus /> Eveniment Nou</button>
            <button style={A.btnW} onClick={handleLogout}>Logout</button>
          </div>
        </div>

        {/* CREATE MODAL */}
        {showCreate && (
          <div style={A.overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) setShowCreate(false); }}>
            <div style={A.modal} onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ fontWeight: 400, color: '#1a1a1a' }}>Eveniment Nou</h3>
                <button style={A.btnGhost} onClick={() => setShowCreate(false)}><Icons.X /></button>
              </div>
              <form onSubmit={handleCreate}>
                <div style={A.formGrid}>
                  <div style={A.formFull}><div style={A.label}>Nume eveniment *</div><input style={A.input} placeholder="ex: Nunta Ana & Mihai" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required /></div>
                  <div><div style={A.label}>Data *</div><input style={A.input} type="date" value={form.date} onChange={e => setForm(p => ({ ...p, date: e.target.value }))} required /></div>
                  <div><div style={A.label}>Tip eveniment</div><select style={A.select} value={form.event_type} onChange={e => setForm(p => ({ ...p, event_type: e.target.value }))}><option value="wedding">Nuntă</option><option value="baptism">Botez</option><option value="birthday">Aniversare</option><option value="corporate">Corporate</option><option value="other">Altceva</option></select></div>
                  <div style={A.formFull}><div style={A.label}>Numele cuplului / gazdei</div><input style={A.input} placeholder="ex: Ana & Mihai" value={form.couple_names} onChange={e => setForm(p => ({ ...p, couple_names: e.target.value }))} /></div>
                  <div style={A.formFull}><div style={A.label}>Descriere (textul afișat invitaților)</div><textarea style={{ ...A.input, resize: 'vertical', minHeight: 60 }} placeholder="ex: Adaugă fotografiile și videoclipurile tale și contribuie la povestea nunții." value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} rows={2} /></div>
                  <div style={A.formFull}>
                    <div style={A.label}>URL personalizat <span style={{ color: '#aaa', fontWeight: 300 }}>(opțional)</span></div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 0, background: '#f5f5f5', borderRadius: 8, border: '1px solid #e0e0e0', overflow: 'hidden' }}>
                      <span style={{ padding: '10px 10px', fontSize: '0.82rem', color: '#aaa', whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', background: '#ececec' }}>domeniu.ro/event/</span>
                      <input style={{ ...A.input, border: 'none', background: 'transparent', borderRadius: 0, flex: 1 }} placeholder="nunta-ana-si-mihai" value={form.custom_slug} onChange={e => setForm(p => ({ ...p, custom_slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-') }))} />
                    </div>
                    <div style={{ fontSize: '0.74rem', color: '#aaa', marginTop: 4 }}>Lasă gol pentru URL automat. Doar litere mici, cifre și -</div>
                  </div>
                  {!password && (
                    <div style={A.formFull}><div style={A.label}>Parolă Admin *</div><input style={A.input} type="password" placeholder="Alege o parolă" value={form.admin_password} onChange={e => setForm(p => ({ ...p, admin_password: e.target.value }))} required={!password} /></div>
                  )}
                  <div style={{ ...A.formFull, display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0' }}>
                    <button type="button" onClick={() => setForm(p => ({ ...p, public_gallery: p.public_gallery ? 0 : 1 }))}
                      style={{ width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer', background: form.public_gallery ? '#F5C518' : '#ddd', position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}>
                      <div style={{ width: 18, height: 18, borderRadius: '50%', background: 'white', position: 'absolute', top: 3, left: form.public_gallery ? 23 : 3, transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                    </button>
                    <div>
                      <div style={{ fontSize: '0.86rem', fontWeight: 500, color: '#333' }}>Galerie publică pentru invitați</div>
                      <div style={{ fontSize: '0.74rem', color: '#999', fontWeight: 300 }}>{form.public_gallery ? 'Invitații pot vedea pozele celorlalți' : 'Doar tu vezi pozele (din admin)'}</div>
                    </div>
                  </div>
                </div>
                <button type="submit" style={{ ...A.btnY, width: '100%', marginTop: 20 }} disabled={creating}>{creating ? 'Se creează...' : 'Creează Eveniment'}</button>
              </form>
            </div>
          </div>
        )}

        {/* EVENTS LIST */}
        {events.length === 0 && !showCreate ? (
          <div style={{ textAlign: 'center', padding: '48px 20px', color: '#999' }}>
            <Icons.Camera />
            <h3 style={{ marginTop: 12, fontWeight: 300, color: '#555' }}>Niciun eveniment</h3>
            <p style={{ fontWeight: 300, marginTop: 4 }}>Creează primul tău eveniment pentru a genera un cod QR.</p>
          </div>
        ) : (
          events.map(event => (
            <div key={event.id} style={A.eventItem} onClick={() => navigate(`/admin/event/${event.slug}`)}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '1.1rem', fontWeight: 400, color: '#1a1a1a', marginBottom: 4 }}>{event.name}</div>
                <div style={{ fontSize: '0.78rem', color: '#999', display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'center', fontWeight: 300 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Icons.Calendar /> {new Date(event.date).toLocaleDateString('ro-RO')}</span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Icons.Image /> {event.upload_count} fișiere</span>
                  <span>{formatSize(event.total_size)}</span>
                  {!event.is_active && <span style={{ ...A.badge, ...A.badgeRed }}>Inactiv</span>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button style={{ ...A.btnGhost, padding: 6 }} onClick={e => { e.stopPropagation(); navigate(`/admin/event/${event.slug}`); }}><Icons.Settings /></button>
                <button style={{ ...A.btnGhost, padding: 6, color: '#d45050' }} onClick={e => { e.stopPropagation(); handleDelete(event.slug); }}><Icons.Trash /></button>
              </div>
            </div>
          ))
        )}
      </div>
      <div style={A.footer}><img src={OMG_LOGO} alt="OMG!" style={{ height: 50, maxWidth: '70%', objectFit: 'contain', opacity: 0.9 }} /></div>
    </div>
  );
}

/* ===== ADMIN EVENT DETAIL ===== */
function AdminEventDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const password = localStorage.getItem('qr_admin_pw') || '';
  const [event, setEvent] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [tab, setTab] = useState('qr');
  const [lightboxIndex, setLightboxIndex] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [autoCloseDays, setAutoCloseDays] = useState('');

  useEffect(() => {
    api.authEvent(slug, password)
      .then(data => { setEvent(data.event); setAutoCloseDays(data.event.auto_close_days ?? ''); setLoading(false); })
      .catch(() => { navigate('/admin'); });
  }, [slug, password, navigate]);

  useEffect(() => {
    if (tab === 'gallery') api.getAllGallery(slug).then(data => setGallery(data.files));
  }, [tab, slug]);

  const handleDownloadAll = async () => {
    setDownloading(true);
    try { await api.downloadAll(slug, password); toast('Descărcare inițiată!', 'success'); }
    catch { toast('Eroare la descărcare.', 'error'); }
    finally { setDownloading(false); }
  };

  const handleDeleteUpload = async (uploadId) => {
    try { await api.deleteUpload(uploadId, password); setGallery(prev => prev.filter(f => f.id !== uploadId)); toast('Fișier șters.', 'success'); }
    catch { toast('Eroare la ștergere.', 'error'); }
  };

  const [archiving, setArchiving] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [editForm, setEditForm] = React.useState({});

  const handleEditOpen = () => {
    setEditForm({ name: event.name, date: event.date, couple_names: event.couple_names || '', description: event.description || '' });
    setEditMode(true);
  };

  const handleEditSave = async () => {
    try {
      await api.updateEvent(slug, { admin_password: password, ...editForm });
      setEvent(prev => ({ ...prev, ...editForm }));
      setEditMode(false);
      toast('Eveniment actualizat.', 'success');
    } catch { toast('Eroare la salvare.', 'error'); }
  };

  const handleToggleActive = async () => {
    if (event.is_active) {
      const confirmed = window.confirm(
        `Închizi upload-ul și arhivezi toate pozele pe Nextcloud?\n\nFișierele vor fi mutate pe Nextcloud cu acces 90 zile, apoi șterse de pe server.\n\nAceastă acțiune nu poate fi anulată.`
      );
      if (!confirmed) return;
      setArchiving(true);
      try {
        const result = await api.archiveEvent(slug, password);
        setEvent(prev => ({ ...prev, is_active: 0, nextcloud_share_url: result.nextcloud_share_url }));
        toast('Eveniment arhivat pe Nextcloud cu succes!', 'success');
      } catch (err) {
        toast(err.message || 'Eroare la arhivare.', 'error');
      } finally {
        setArchiving(false);
      }
    } else {
      try {
        await api.updateEvent(slug, { admin_password: password, is_active: 1 });
        setEvent(prev => ({ ...prev, is_active: 1 }));
        toast('Upload activat.', 'success');
      } catch { toast('Eroare.', 'error'); }
    }
  };

  const handleSaveAutoClose = async () => {
    try {
      const val = autoCloseDays === '' ? null : parseInt(autoCloseDays, 10);
      await api.updateEvent(slug, { admin_password: password, auto_close_days: val });
      setEvent(prev => ({ ...prev, auto_close_days: val }));
      toast(val == null ? 'Auto-închidere dezactivată.' : `Upload se va închide automat după ${val} zile.`, 'success');
    } catch { toast('Eroare.', 'error'); }
  };

  const handleTogglePublicGallery = async () => {
    try {
      await api.updateEvent(slug, { admin_password: password, public_gallery: event.public_gallery ? 0 : 1 });
      setEvent(prev => ({ ...prev, public_gallery: prev.public_gallery ? 0 : 1 }));
      toast(event.public_gallery ? 'Galeria publică dezactivată.' : 'Galeria publică activată.', 'success');
    } catch { toast('Eroare.', 'error'); }
  };

  // Cand e pornit, invitatii isi iau singuri pozele din galerie, inclusiv pe
  // ale celorlalti. Se opreste doar daca vrei sa livrezi tu materialul.
  const handleToggleGuestDownload = async () => {
    try {
      await api.updateEvent(slug, { admin_password: password, guest_download: event.guest_download ? 0 : 1 });
      setEvent(prev => ({ ...prev, guest_download: prev.guest_download ? 0 : 1 }));
      toast(event.guest_download ? 'Descărcarea pentru invitați e oprită.' : 'Invitații pot descărca pozele.', 'success');
    } catch { toast('Eroare.', 'error'); }
  };

  if (loading) return <div style={{ ...A.page, alignItems: 'center', justifyContent: 'center' }}><div className="spinner" /></div>;
  if (!event) return null;

  return (
    <div style={A.page}>
      <AdminHeader />

      {editMode && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '100%', maxWidth: 480 }}>
            <h3 style={{ margin: '0 0 20px', fontWeight: 500 }}>Editează evenimentul</h3>
            <div style={{ marginBottom: 14 }}>
              <div style={A.inputLabel}>Nume eveniment</div>
              <input style={A.input} value={editForm.name} onChange={e => setEditForm(p => ({ ...p, name: e.target.value }))} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={A.inputLabel}>Numele mirilor / ocazia</div>
              <input style={A.input} value={editForm.couple_names} onChange={e => setEditForm(p => ({ ...p, couple_names: e.target.value }))} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={A.inputLabel}>Data evenimentului</div>
              <input style={A.input} type="date" value={editForm.date} onChange={e => setEditForm(p => ({ ...p, date: e.target.value }))} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <div style={A.inputLabel}>Descriere</div>
              <textarea style={{ ...A.input, minHeight: 80, resize: 'vertical' }} value={editForm.description} onChange={e => setEditForm(p => ({ ...p, description: e.target.value }))} />
            </div>
            <div style={{ fontSize: '0.8rem', color: '#888', marginBottom: 16 }}>⚠️ Slug-ul și QR-ul rămân neschimbate.</div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button style={A.btnW} onClick={() => setEditMode(false)}>Anulează</button>
              <button style={A.btnY} onClick={handleEditSave}>Salvează</button>
            </div>
          </div>
        </div>
      )}
      <div style={A.body}>
        <button style={{ ...A.btnGhost, marginBottom: 16 }} onClick={() => navigate('/admin')}>
          <Icons.ChevronLeft /> Înapoi
        </button>

        {/* Event Header */}
        <div style={{ ...A.card, marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <h2 style={{ fontWeight: 400, color: '#1a1a1a', fontSize: '1.4rem', margin: 0 }}>{event.name}</h2>
                <button style={{ ...A.btnGhost, padding: '2px 10px', fontSize: '0.8rem' }} onClick={handleEditOpen}>✏️ Editează</button>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                <span style={{ ...A.badge, ...A.badgeYellow }}><Icons.Calendar /> {new Date(event.date).toLocaleDateString('ro-RO')}</span>
                {event.is_active
                  ? <span style={{ ...A.badge, ...A.badgeGreen }}>Activ</span>
                  : <span style={{ ...A.badge, ...A.badgeRed }}>Inactiv</span>
                }
                <span style={{ ...A.badge, ...(event.public_gallery ? A.badgeGreen : A.badgeGrey) }}>
                  {event.public_gallery ? 'Galerie publică' : 'Galerie privată'}
                </span>
                <span style={{ ...A.badge, ...(event.public_gallery && event.guest_download ? A.badgeGreen : A.badgeGrey) }}>
                  {event.public_gallery && event.guest_download ? 'Invitații pot descărca' : 'Descărcare oprită'}
                </span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {archiving ? (
                <button style={A.btnDanger} disabled>⏳ Arhivare pe Nextcloud...</button>
              ) : event.nextcloud_share_url ? (
                <a href={event.nextcloud_share_url} target="_blank" rel="noopener noreferrer" style={{ ...A.btnW, textDecoration: 'none' }}>☁️ Galerie Nextcloud</a>
              ) : (
                <button style={event.is_active ? A.btnDanger : A.btnW} onClick={handleToggleActive}>{event.is_active ? '🔒 Închide Upload' : '🔓 Deschide Upload'}</button>
              )}
              <button style={A.btnW} onClick={handleTogglePublicGallery}>{event.public_gallery ? 'Ascunde Galeria' : 'Arată Galeria'}</button>
              <button style={A.btnW} onClick={handleToggleGuestDownload} title={event.public_gallery ? '' : 'Descărcarea funcționează doar cu galeria publică'}>
                {event.guest_download ? 'Oprește Descărcarea' : 'Permite Descărcarea'}
              </button>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: '0.85rem', color: '#555', whiteSpace: 'nowrap' }}>Auto-închidere după</span>
              <input
                type="number"
                min="0"
                placeholder="zile"
                value={autoCloseDays}
                onChange={e => setAutoCloseDays(e.target.value)}
                style={{ ...A.input, width: 80, padding: '6px 10px' }}
              />
              <span style={{ fontSize: '0.85rem', color: '#555', whiteSpace: 'nowrap' }}>zile de la eveniment</span>
              <button style={A.btnY} onClick={handleSaveAutoClose}>Salvează</button>
              {event.auto_close_days != null && (
                <span style={{ fontSize: '0.8rem', color: '#888' }}>
                  (se închide pe {new Date(new Date(event.date).setDate(new Date(event.date).getDate() + event.auto_close_days)).toLocaleDateString('ro-RO')})
                </span>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 0 }}>
              <button style={A.btnY} onClick={handleDownloadAll} disabled={downloading}>
                <Icons.Download /> {downloading ? 'Se descarcă...' : 'Descarcă (.zip)'}
              </button>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={A.tabs}>
          {['qr', 'gallery', 'slideshow', 'audio', 'link'].map(t => (
            <button key={t} style={{ ...A.tab, ...(tab === t ? A.tabOn : {}) }} onClick={() => setTab(t)}>
              {t === 'qr' && <><Icons.QR /> QR</>}
              {t === 'gallery' && <><Icons.Image /> Galerie</>}
              {t === 'slideshow' && <>📺 Slideshow</>}
              {t === 'audio' && <>🎙️ Audio</>}
              {t === 'link' && <><Icons.Upload /> Link</>}
            </button>
          ))}
        </div>

        {/* QR TAB */}
        {tab === 'qr' && (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#777', marginBottom: 20, fontWeight: 300 }}>Printează acest cod QR pe carduri și pune-le pe mese.</p>
            <div style={{ background: '#fff', borderRadius: 16, padding: 28, display: 'inline-block', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
              <img src={api.getQRCodeUrl(slug)} alt="QR Code" width="260" height="260" style={{ display: 'block' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 20 }}>
              <a href={api.getQRCodeUrl(slug, 'png')} download={`${slug}_qr.png`} style={{ ...A.btnW, textDecoration: 'none' }}><Icons.Download /> PNG</a>
              <a href={api.getQRCodeUrl(slug, 'svg')} download={`${slug}_qr.svg`} style={{ ...A.btnW, textDecoration: 'none' }}><Icons.Download /> SVG</a>
            </div>
            <div style={{ ...A.card, marginTop: 24, textAlign: 'left' }}>
              <div style={A.label}>Link pentru invitați</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <input style={A.input} readOnly value={`${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/event/${slug}`} onClick={e => e.target.select()} />
                <button style={A.btnY} onClick={() => { navigator.clipboard.writeText(`${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/event/${slug}`); toast('Link copiat!', 'success'); }}>Copiază</button>
              </div>
            </div>
          </div>
        )}

        {/* GALLERY TAB */}
        {tab === 'gallery' && (
          <div>
            {gallery.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                <Icons.Image />
                <p style={{ marginTop: 8, fontWeight: 300 }}>Niciun fișier încărcat încă.</p>
              </div>
            ) : (
              <div className="gallery-grid">
                {gallery.map((file, i) => (
                  <div key={file.id} className="gallery-item">
                    <div onClick={() => setLightboxIndex(i)}>
                      {file.file_type === 'video' ? (
                        <>
                          {file.thumbnail_name
                            ? <img src={api.getFileUrl(file.thumbnail_url)} alt="" loading="lazy" />
                            // Fara poster, Safari lasa elementul gol; fundalul inchis
                          // plus badge-ul de play il fac sa arate a clip, nu a eroare.
                          : <video src={api.getFileUrl(file.url)} muted preload="metadata" playsInline style={{ background: '#1a1a1a' }} />}
                          <div className="video-badge"><Icons.Play /></div>
                        </>
                      ) : file.file_type === 'audio' ? (
                        <AudioTile />
                      ) : (
                        <img src={api.getFileUrl(file.thumbnail_url)} alt="" loading="lazy" />
                      )}
                    </div>
                    {(file.uploader_name || file.message) && (
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,0.85))', padding: '24px 8px 6px', pointerEvents: 'none' }}>
                        {file.uploader_name && <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#fff' }}>{file.uploader_name}</div>}
                        {file.message && <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.7)', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{file.message}</div>}
                      </div>
                    )}
                    <button className="delete-btn" onClick={() => handleDeleteUpload(file.id)}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* SLIDESHOW TAB */}
        {tab === 'slideshow' && (
          <div>
            <div style={A.card}>
              <div style={A.label}>Live Slideshow / Photo Wall</div>
              <p style={{ color: '#777', marginBottom: 12, fontSize: '0.88rem', fontWeight: 300 }}>
                Deschide acest link pe un TV sau proiector. Pozele apar automat pe măsură ce invitații le încarcă.
              </p>
              <div style={{ display: 'flex', gap: 8 }}>
                <input style={A.input} readOnly value={`${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/slideshow/${slug}`} onClick={e => e.target.select()} />
                <button style={A.btnY} onClick={() => { navigator.clipboard.writeText(`${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/slideshow/${slug}`); toast('Link copiat!', 'success'); }}>Copiază</button>
              </div>
              <a href={`/slideshow/${slug}`} target="_blank" rel="noopener noreferrer" style={{ ...A.btnW, width: '100%', textDecoration: 'none', justifyContent: 'center', marginTop: 12 }}>
                📺 Deschide Slideshow
              </a>
            </div>
            <div style={A.card}>
              <div style={A.label}>Cum funcționează</div>
              <div style={{ fontSize: '0.88rem', color: '#555', fontWeight: 300, lineHeight: 1.8 }}>
                <div>✅ Deschide link-ul pe un laptop conectat la TV/proiector</div>
                <div>✅ Slide-ul se actualizează automat la fiecare 5 secunde</div>
                <div>✅ Pozele noi apar automat fără refresh</div>
                <div>✅ Afișează numele celui care a trimis poza</div>
                <div>✅ Funcționează fullscreen (apasă F11)</div>
              </div>
            </div>
          </div>
        )}

        {/* AUDIO GUESTBOOK TAB */}
        {tab === 'audio' && (
          <AdminAudioTab slug={slug} password={password} />
        )}

        {/* LINK TAB */}
        {tab === 'link' && (
          <div>
            <div style={A.card}>
              <div style={A.label}>Link Public</div>
              <p style={{ color: '#777', marginBottom: 12, fontSize: '0.88rem', fontWeight: 300 }}>Trimite acest link invitaților.</p>
              <div style={{ display: 'flex', gap: 8 }}>
                <input style={A.input} readOnly value={`${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/event/${slug}`} onClick={e => e.target.select()} />
                <button style={A.btnY} onClick={() => { navigator.clipboard.writeText(`${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/event/${slug}`); toast('Link copiat!', 'success'); }}>Copiază</button>
              </div>
            </div>
            <div style={A.card}>
              <div style={A.label}>Partajează pe WhatsApp</div>
              <a href={`https://wa.me/?text=${encodeURIComponent(`Încarcă pozele de la ${event.name} aici: ${(process.env.REACT_APP_PUBLIC_URL || window.location.origin)}/event/${slug}`)}`} target="_blank" rel="noopener noreferrer" style={{ ...A.btnW, width: '100%', textDecoration: 'none', justifyContent: 'center' }}>
                Trimite pe WhatsApp
              </a>
            </div>
          </div>
        )}

        {/* LIGHTBOX */}
        {lightboxIndex >= 0 && (
          <Lightbox
            files={gallery}
            currentIndex={lightboxIndex}
            onClose={() => setLightboxIndex(-1)}
            onNav={dir => setLightboxIndex(prev => Math.max(0, Math.min(gallery.length - 1, prev + dir)))}
          />
        )}
      </div>
      <div style={A.footer}><img src={OMG_LOGO} alt="OMG!" style={{ height: 50, maxWidth: '70%', objectFit: 'contain', opacity: 0.9 }} /></div>
    </div>
  );
}

/* ===== ADMIN AUDIO TAB ===== */
function AdminAudioTab({ slug, password }) {
  const toast = useToast();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [welcomeAudioUrl, setWelcomeAudioUrl] = useState(null);
  const [welcomeTitle, setWelcomeTitle] = useState('');
  const [uploadingWelcome, setUploadingWelcome] = useState(false);
  const [savingTitle, setSavingTitle] = useState(false);
  const welcomeInputRef = useRef(null);

  useEffect(() => {
    api.getGuestbook(slug).then(data => {
      setMessages(data.messages);
      setWelcomeAudioUrl(data.welcome_audio_url || null);
      setWelcomeTitle(data.welcome_title || '');
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [slug]);

  const handleSaveTitle = async () => {
    setSavingTitle(true);
    try {
      await api.updateEvent(slug, { admin_password: password, welcome_title: welcomeTitle });
      toast('Titlu salvat!', 'success');
    } catch { toast('Eroare.', 'error'); }
    finally { setSavingTitle(false); }
  };

  const handleWelcomeUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingWelcome(true);
    try {
      const data = await api.uploadWelcomeAudio(slug, file, password);
      setWelcomeAudioUrl(data.url);
      toast('Mesaj de întâmpinare încărcat!', 'success');
    } catch { toast('Eroare la încărcare.', 'error'); }
    finally { setUploadingWelcome(false); e.target.value = ''; }
  };

  const handleWelcomeDelete = async () => {
    if (!window.confirm('Ștergi mesajul de întâmpinare?')) return;
    try {
      await api.deleteWelcomeAudio(slug, password);
      setWelcomeAudioUrl(null);
      toast('Mesaj de întâmpinare șters.', 'success');
    } catch { toast('Eroare.', 'error'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Sigur vrei să ștergi acest mesaj vocal?')) return;
    try {
      await api.deleteUpload(id, password);
      setMessages(prev => prev.filter(m => m.id !== id));
      toast('Mesaj șters.', 'success');
    } catch { toast('Eroare.', 'error'); }
  };

  const formatDate = (d) => new Date(d + 'Z').toLocaleString('ro-RO', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  const formatSize = (b) => b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : (b / 1024).toFixed(0) + ' KB';

  if (loading) return <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" /></div>;

  return (
    <div>
      {/* Welcome audio section */}
      <div style={{ ...A.card, marginBottom: 16, background: '#fffbea', border: '1px solid #F5C518' }}>
        <div style={A.label}>🎙️ Mesaj de întâmpinare</div>
        <p style={{ color: '#777', marginBottom: 12, fontSize: '0.88rem', fontWeight: 300 }}>
          Înregistrezi un mesaj audio (ex: "Bine ați venit! Lăsați-ne un mesaj vocal după semnal.") și îl încarci ca MP3. Invitații îl aud înainte să înregistreze.
        </p>
        <div style={{ marginBottom: 12 }}>
          <div style={A.label}>Titlu afișat invitaților</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input style={{ ...A.input, flex: 1 }} value={welcomeTitle} onChange={e => setWelcomeTitle(e.target.value)} placeholder="ex: Mesaj de la Ana & Mihai" />
            <button style={A.btnY} onClick={handleSaveTitle} disabled={savingTitle}>{savingTitle ? '...' : 'Salvează'}</button>
          </div>
        </div>
        {welcomeAudioUrl ? (
          <div>
            <WelcomeAudioPlayer src={api.getFileUrl(welcomeAudioUrl)} />
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <button style={{ ...A.btnW, flex: 1 }} onClick={() => welcomeInputRef.current?.click()} disabled={uploadingWelcome}>
                {uploadingWelcome ? 'Se încarcă...' : '↑ Înlocuiește'}
              </button>
              <button style={{ ...A.btnDanger }} onClick={handleWelcomeDelete}>Șterge</button>
            </div>
          </div>
        ) : (
          <button style={{ ...A.btnY, width: '100%' }} onClick={() => welcomeInputRef.current?.click()} disabled={uploadingWelcome}>
            {uploadingWelcome ? 'Se încarcă...' : '↑ Încarcă mesaj MP3'}
          </button>
        )}
        <input ref={welcomeInputRef} type="file" accept="audio/*,.mp3,.m4a,.wav,.ogg" style={{ display: 'none' }} onChange={handleWelcomeUpload} />
      </div>

      <div style={A.card}>
        <div style={A.label}>Mesaje vocale de la invitați</div>
        <p style={{ color: '#777', marginBottom: 12, fontSize: '0.88rem', fontWeight: 300 }}>
          Invitații pot lăsa mesaje vocale scanând codul QR. Mesajele apar aici și în ZIP.
        </p>
      </div>
      {messages.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🎙️</div>
          <p style={{ fontWeight: 300 }}>Niciun mesaj vocal încă.</p>
          <p style={{ fontSize: '0.82rem', fontWeight: 300, marginTop: 4 }}>Invitații pot înregistra mesaje vocale din pagina evenimentului.</p>
        </div>
      ) : (
        messages.map(m => (
          <div key={m.id} style={{ ...A.card, display: 'flex', alignItems: 'center', gap: 14, marginBottom: 10 }}>
            <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#F5C518', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '1.1rem', fontWeight: 700, color: '#1a1a1a' }}>
              {(m.uploader_name || '?')[0].toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 500, color: '#333', fontSize: '0.9rem' }}>{m.uploader_name || 'Anonim'}</span>
                <span style={{ fontSize: '0.72rem', color: '#999', fontWeight: 300 }}>{formatDate(m.uploaded_at)} • {formatSize(m.file_size)}</span>
              </div>
              <audio src={api.getFileUrl(m.url)} controls style={{ width: '100%', height: 32, marginTop: 6 }} />
            </div>
            <button onClick={() => handleDelete(m.id)} style={{ ...A.btnDanger, padding: '6px 10px', fontSize: '0.75rem' }}>✕</button>
          </div>
        ))
      )}
    </div>
  );
}

/* ===== LIVE SLIDESHOW / PHOTO WALL ===== */
function LiveSlideshow() {
  const { slug } = useParams();
  const [photos, setPhotos] = useState([]);
  const [current, setCurrent] = useState(0);
  const [eventInfo, setEventInfo] = useState(null);
  const [total, setTotal] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const lastFetchRef = useRef('1970-01-01');
  const timerRef = useRef(null);

  // Initial load + polling for new photos
  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const data = await api.getSlideshow(slug, '1970-01-01');
        setEventInfo(data.event);
        setTotal(data.total);
        if (data.files.length > 0) {
          setPhotos(data.files);
          lastFetchRef.current = data.files[data.files.length - 1].uploaded_at;
        }
      } catch {}
    };
    fetchPhotos();

    // Poll every 5 seconds for new photos
    const poll = setInterval(async () => {
      try {
        const data = await api.getSlideshow(slug, lastFetchRef.current);
        if (data.files.length > 0) {
          setPhotos(prev => [...prev, ...data.files]);
          setTotal(data.total);
          lastFetchRef.current = data.files[data.files.length - 1].uploaded_at;
        }
      } catch {}
    }, 5000);

    return () => clearInterval(poll);
  }, [slug]);

  // Auto-advance slideshow every 6 seconds
  useEffect(() => {
    if (photos.length === 0) return;
    timerRef.current = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setCurrent(prev => (prev + 1) % photos.length);
        setTransitioning(false);
      }, 600);
    }, 6000);
    return () => clearInterval(timerRef.current);
  }, [photos.length]);

  const LS = {
    page: { position: 'fixed', inset: 0, background: '#000', fontFamily: "'Roboto', sans-serif", display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    topBar: { position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10, background: 'linear-gradient(to bottom, rgba(0,0,0,0.7), transparent)', padding: '20px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    bottomBar: { position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 10, background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', padding: '30px' },
    photo: { position: 'absolute', inset: 0, objectFit: 'contain', width: '100%', height: '100%', transition: 'opacity 0.6s ease' },
    waiting: { position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#fff' },
  };

  if (!eventInfo) return <div style={LS.page}><div style={LS.waiting}><div className="spinner" /></div></div>;

  if (photos.length === 0) return (
    <div style={LS.page}>
      <GlobalRobotoStyle />
      <div style={LS.waiting}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>📸</div>
        <h2 style={{ fontWeight: 300, color: '#fff', fontSize: '2rem' }}>{eventInfo.couple_names || eventInfo.name}</h2>
        <p style={{ color: '#999', fontSize: '1.2rem', marginTop: 10, fontWeight: 300 }}>Se așteaptă primele fotografii...</p>
        <p style={{ color: '#555', fontSize: '0.9rem', marginTop: 20, fontWeight: 300 }}>Scanați codul QR pentru a încărca poze</p>
      </div>
    </div>
  );

  const photo = photos[current];
  return (
    <div style={LS.page}>
      <GlobalRobotoStyle />
      {/* Photo */}
      <img
        key={photo.id}
        src={api.getFileUrl(photo.url)}
        alt=""
        style={{ ...LS.photo, opacity: transitioning ? 0 : 1 }}
      />

      {/* Top Bar */}
      <div style={LS.topBar}>
        <div>
          <div style={{ color: '#F5C518', fontSize: '1.2rem', fontWeight: 700 }}>QR Stories</div>
          <div style={{ color: '#aaa', fontSize: '0.8rem', fontWeight: 300 }}>{eventInfo.couple_names || eventInfo.name}</div>
        </div>
        <div style={{ color: '#888', fontSize: '0.85rem', fontWeight: 300 }}>
          {current + 1} / {photos.length} • {total} total
        </div>
      </div>

      {/* Bottom Bar - uploader info */}
      {photo.uploader_name && (
        <div style={LS.bottomBar}>
          <div style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 400 }}>De la: {photo.uploader_name}</div>
          {photo.message && <div style={{ color: '#ccc', fontSize: '0.9rem', marginTop: 4, fontWeight: 300 }}>{photo.message}</div>}
        </div>
      )}
    </div>
  );
}

/* ===== WELCOME AUDIO PLAYER (custom — no download, no speed control) ===== */
function WelcomeAudioPlayer({ src }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) { audioRef.current.pause(); setPlaying(false); }
    else { audioRef.current.play(); setPlaying(true); }
  };
  const handleTimeUpdate = () => {
    if (!audioRef.current) return;
    const ct = audioRef.current.currentTime;
    const dur = audioRef.current.duration || 1;
    setCurrentTime(ct);
    setProgress((ct / dur) * 100);
  };
  const handleEnded = () => { setPlaying(false); setProgress(0); setCurrentTime(0); };
  const seek = (e) => {
    if (!audioRef.current || !duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    audioRef.current.currentTime = ((e.clientX - rect.left) / rect.width) * duration;
  };
  const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <audio ref={audioRef} src={src} onTimeUpdate={handleTimeUpdate} onLoadedMetadata={e => setDuration(e.target.duration)} onEnded={handleEnded} style={{ display: 'none' }} />
      <button onClick={toggle} style={{ width: 36, height: 36, borderRadius: '50%', border: 'none', background: '#F5C518', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {playing
          ? <svg width="12" height="12" viewBox="0 0 24 24" fill="#1a1a1a"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg>
          : <svg width="12" height="12" viewBox="0 0 24 24" fill="#1a1a1a"><polygon points="5,3 19,12 5,21"/></svg>
        }
      </button>
      <div style={{ flex: 1 }}>
        <div onClick={seek} style={{ height: 4, background: '#e0e0e0', borderRadius: 2, cursor: 'pointer', overflow: 'hidden' }}>
          <div style={{ height: '100%', width: `${progress}%`, background: '#F5C518', borderRadius: 2, transition: 'width 0.1s linear' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}>
          <span style={{ fontSize: '0.7rem', color: '#999', fontFamily: "'Roboto', sans-serif" }}>{fmt(currentTime)}</span>
          {duration > 0 && <span style={{ fontSize: '0.7rem', color: '#999', fontFamily: "'Roboto', sans-serif" }}>{fmt(duration)}</span>}
        </div>
      </div>
    </div>
  );
}

/* ===== AUDIO GUESTBOOK RECORDER (used inside EventPage) ===== */
function AudioGuestbookDemo() {
  const toast = useToast();
  return (
    <div style={{ background: '#fff', borderRadius: 16, padding: '24px 20px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginTop: 16, textAlign: 'center' }}>
      <div style={{ fontSize: '0.92rem', fontWeight: 500, color: '#1a1a1a', marginBottom: 4 }}>Mesaj vocal</div>
      <div style={{ fontSize: '0.78rem', color: '#888', fontWeight: 300, marginBottom: 16 }}>Lasă un mesaj vocal</div>
      <button onClick={() => toast('Modul demo — mesajele audio nu se salvează.', 'info')}
        style={{ width: 64, height: 64, borderRadius: '50%', border: 'none', cursor: 'pointer', background: '#F5C518', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="2"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
      </button>
      <div style={{ fontSize: '0.75rem', color: '#aaa', marginTop: 8 }}>Max 60s</div>
    </div>
  );
}

function AudioGuestbook({ slug, lang, uploaderName }) {
  const toast = useToast();
  const [recording, setRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [sent, setSent] = useState(false);
  const [welcomeAudioUrl, setWelcomeAudioUrl] = useState(null);
  const [welcomeTitle, setWelcomeTitle] = useState('');
  const [duration, setDuration] = useState(0);
  const mediaRecorder = useRef(null);
  const chunks = useRef([]);
  const timerRef = useRef(null);

  const t = lang === 'ro' ? {
    title: 'Mesaj vocal',
    desc: 'Lasă un mesaj vocal',
    record: 'Înregistrează mesaj',
    stop: 'Oprește',
    send: 'Trimite mesajul',
    sent: 'Mesaj trimis!',
    sentDesc: 'Mulțumim pentru mesajul tău vocal.',
    another: 'Trimite altul',
    listen: 'Ascultă mesajele',
    from: 'De la',
    noMessages: 'Nu sunt mesaje vocale încă.',
    seconds: 's',
    recording: 'Se înregistrează...',
    preview: 'Previzualizare',
    discard: 'Renunță',
    micError: 'Nu s-a putut accesa microfonul.',
  } : {
    title: 'Voice Message',
    desc: 'Leave a voice message for the couple',
    record: 'Record message',
    stop: 'Stop',
    send: 'Send message',
    sent: 'Message sent!',
    sentDesc: 'Thank you for your voice message.',
    another: 'Send another',
    listen: 'Listen to messages',
    from: 'From',
    noMessages: 'No voice messages yet.',
    seconds: 's',
    recording: 'Recording...',
    preview: 'Preview',
    discard: 'Discard',
    micError: 'Could not access microphone.',
  };

  useEffect(() => {
    api.getGuestbook(slug).then(data => {
      setWelcomeAudioUrl(data.welcome_audio_url || null);
      setWelcomeTitle(data.welcome_title || '');
    }).catch(() => {});
  }, [slug]);

  const startRecording = async () => {
    if (process.env.REACT_APP_DEMO_MODE === 'true') {
      toast('Modul demo — mesajele audio nu se salvează.', 'info');
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const options = MediaRecorder.isTypeSupported('audio/webm') ? { mimeType: 'audio/webm' } : {};
      mediaRecorder.current = new MediaRecorder(stream, options);
      chunks.current = [];
      setDuration(0);

      mediaRecorder.current.ondataavailable = (e) => { if (e.data.size > 0) chunks.current.push(e.data); };
      mediaRecorder.current.onstop = () => {
        const blob = new Blob(chunks.current, { type: mediaRecorder.current.mimeType || 'audio/webm' });
        setAudioBlob(blob);
        setAudioUrl(URL.createObjectURL(blob));
        stream.getTracks().forEach(track => track.stop());
        clearInterval(timerRef.current);
      };

      mediaRecorder.current.start();
      setRecording(true);
      timerRef.current = setInterval(() => setDuration(d => d + 1), 1000);

      // Auto-stop after 60 seconds
      setTimeout(() => { if (mediaRecorder.current && mediaRecorder.current.state === 'recording') mediaRecorder.current.stop(); setRecording(false); }, 60000);
    } catch {
      toast(t.micError, 'error');
    }
  };

  const stopRecording = () => {
    if (mediaRecorder.current && mediaRecorder.current.state === 'recording') {
      mediaRecorder.current.stop();
    }
    setRecording(false);
  };

  const discardRecording = () => {
    setAudioBlob(null);
    setAudioUrl(null);
    setDuration(0);
  };

  const sendAudio = async () => {
    if (!audioBlob) return;
    setUploading(true);
    try {
      await api.uploadAudio(slug, audioBlob, uploaderName);
      setSent(true);
      setAudioBlob(null);
      setAudioUrl(null);
    } catch {
      toast(lang === 'ro' ? 'Eroare la trimitere.' : 'Send failed.', 'error');
    } finally {
      setUploading(false);
    }
  };

  const formatDuration = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

  const GS = {
    card: { background: '#fff', borderRadius: 16, padding: '20px', marginTop: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
    recBtn: { width: 64, height: 64, borderRadius: '50%', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease' },
    msgItem: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px', background: '#f9f9f9', borderRadius: 10, marginTop: 8 },
  };

  if (sent) return (
    <div style={{ ...GS.card, textAlign: 'center' }}>
      <div style={{ fontSize: 36, marginBottom: 8 }}>🎙️</div>
      <div style={{ fontWeight: 500, color: '#1a1a1a' }}>{t.sent}</div>
      <p style={{ color: '#888', fontSize: '0.88rem', fontWeight: 300, marginTop: 4 }}>{t.sentDesc}</p>
      <button onClick={() => setSent(false)} style={{ marginTop: 12, background: '#F5C518', border: 'none', borderRadius: 8, padding: '10px 20px', fontFamily: "'Roboto', sans-serif", fontWeight: 500, cursor: 'pointer', color: '#1a1a1a' }}>
        {t.another}
      </button>
    </div>
  );

  return (
    <div>
      {welcomeAudioUrl && (
        <div style={{ ...GS.card, marginBottom: 12, background: '#fffbea', border: '1px solid #F5C518' }}>
          <div style={{ textAlign: 'center', marginBottom: 12 }}>
            <div style={{ fontSize: '0.92rem', fontWeight: 500, color: '#1a1a1a' }}>
              {welcomeTitle || (lang === 'ro' ? 'Mesaj de la miri' : 'Message from the couple')}
            </div>
          </div>
          <WelcomeAudioPlayer src={api.getFileUrl(welcomeAudioUrl)} />
        </div>
      )}
      <div style={GS.card}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: '0.92rem', fontWeight: 500, color: '#1a1a1a' }}>{t.title}</div>
          <div style={{ fontSize: '0.78rem', color: '#888', fontWeight: 300, marginTop: 2 }}>{t.desc}</div>
        </div>

        {!audioBlob ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
            <button
              onClick={recording ? stopRecording : startRecording}
              style={{ ...GS.recBtn, background: recording ? '#d45050' : '#F5C518', color: recording ? '#fff' : '#1a1a1a' }}
            >
              {recording ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12" rx="2" /></svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
              )}
            </button>
            {recording && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#d45050', animation: 'pulse 1s infinite' }} />
                <span style={{ color: '#d45050', fontWeight: 500, fontSize: '0.88rem' }}>{t.recording} {formatDuration(duration)}</span>
              </div>
            )}
            {!recording && <span style={{ color: '#999', fontSize: '0.78rem', fontWeight: 300 }}>Max 60{t.seconds}</span>}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center' }}>
            <div style={{ fontSize: '0.82rem', color: '#555', fontWeight: 300 }}>{t.preview} ({formatDuration(duration)})</div>
            <audio src={audioUrl} controls style={{ width: '100%', maxWidth: 300, height: 36 }} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={discardRecording} style={{ padding: '10px 20px', background: '#f0f0f0', border: 'none', borderRadius: 8, fontFamily: "'Roboto', sans-serif", cursor: 'pointer', fontWeight: 400, color: '#555' }}>
                {t.discard}
              </button>
              <button onClick={sendAudio} disabled={uploading} style={{ padding: '10px 20px', background: '#F5C518', border: 'none', borderRadius: 8, fontFamily: "'Roboto', sans-serif", cursor: 'pointer', fontWeight: 600, color: '#1a1a1a', opacity: uploading ? 0.5 : 1 }}>
                {uploading ? '...' : t.send}
              </button>
            </div>
          </div>
        )}
      </div>


      <style dangerouslySetInnerHTML={{ __html: `@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }` }} />
    </div>
  );
}

/* ===== MAIN APP ===== */
function App() {
  return (
    <ToastProvider>
      <Routes>
        {/* Public pages */}
        <Route path="/" element={process.env.REACT_APP_DEMO_MODE === 'true' ? <Navigate to="/event/demo" replace /> : <HomePage />} />
        <Route path="/event/gerogiana-si-codrut" element={<Navigate to="/event/georgiana-si-codrut" replace />} />
        <Route path="/event/:slug" element={<EventPage />} />
        <Route path="/slideshow/:slug" element={<LiveSlideshow />} />
        
        {/* Admin pages — own header */}
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/event/:slug" element={<AdminEventDetail />} />
      </Routes>
    </ToastProvider>
  );
}

export default App;
